import ProposalForm from '~/src/screens/SearchProductsScreen/ProposalForm';

import * as S from './layout';

const Proposal = () => (
  <S.Container>
    <ProposalForm />
  </S.Container>
);

export default Proposal;
